import { FC } from "react";
import { AppLogo } from "./app-logo";
import UserDropdown from "./user-dropdown";

const Header: FC = () => {
  return (
    <header className="flex h-[--app-header-height] gap-6 p-4 [grid-area:header]">
      <AppLogo />

      <div className="flex grow items-center justify-end gap-2">
        <UserDropdown />
      </div>
    </header>
  );
};

export default Header;
